<template>
  <header class="header header__outbox">
    <div class="outbox__wrapper">
      <div class="outbox__title">
        <h1>{{ $t('outboxScreenHeading') }}</h1>
      </div>
      <div class="outbox__meta">
        <div v-if="contactName">{{ contactName }}</div>
        <div v-else><em>{{ $t('outboxNoName') }}</em></div>
        <div v-if="contactEmail">{{ contactEmail }}</div>
        <div v-else><em>{{ $t('outboxNoEmail') }}</em></div>
      </div>
    </div>
  </header>
</template>

<script>
  import outbox from '@/components/outbox';
  import { mapActions, mapGetters, mapState } from 'vuex';

  export default {
    name: 'OutboxHeader',
    computed: {
      ...mapState(outbox.store.namespace, [
        'contactName',
        'contactEmail',
        'contactPhone'
      ])
    },
  }
</script>

<style lang="scss" scoped>
  @import 'element-theme-chalk/src/mixins/mixins.scss';

  .header {

    &__outbox {
      display: block;
      position: relative;
      overflow-x: hidden;
      width: 100%;
      height: auto;
      box-shadow: 0 0 10px rgba(0, 0, 0, .2);

      @include res(md) {
        height: 60px;

        &:after {
          content: "";
          display: block;
          position: absolute;
          top: 0;
          right: -15px;
          bottom: 0;
          width: 60px;
          height: 100%;
          transform: skew(-23deg);
          background: #ED1C2E;
        }
      }
    }
  }

  .outbox__wrapper {
    display: flex;
    flex-direction: column;
    margin-left: 40px;
    margin-right: 40px;

    @include res(md) {
      flex-direction: row;
      align-items: flex-end;
      margin-right: 80px;
    }
  }

  .outbox__title {
    flex-grow: 1;
    margin: 16px 0;
    text-align: left;

    @include res(md) {
      margin: 0 40px 0 0;
      text-align: right;
    }

    h1 {
      margin: 0;

      @include res(md) {
        line-height: 60px
      }
    }
  }

  .outbox__meta {
    position: relative;
    width: auto;
    height: 60px;
    padding: 0 40px;
    margin: 0 -40px;
    background: #000000;
    color: #ffffff;

    @include res(md) {
      padding: 0 30px;
      margin: 0;

      &:before,
      &:after {
        content: "";
        display: block;
        position: absolute;
        top: 0;
        bottom: 0;
        width: 30px;
        height: 100%;
        transform: skew(-23deg);
      }

      &:before {
        left: -15px;
        background: #000000;
      }

      &:after {
        right: -15px;
        background: #000000;
      }
    }

    div {
      margin: 0;

      &:first-child {
        font-weight: 700;
        margin-top: 6px;
      }
    }
  }
</style>
